import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function Popup() {
  const [showPopup, setShowPopup] = useState(false);

  // Show popup automatically when page loads
  useEffect(() => {
    setShowPopup(true);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="" >


      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" style={{
          backgroundImage: 'url(https://spst.in/images/bg-pooja.jpg)', backgroundSize: 'cover', backgroundPosition: 'center'
        }}>

          <div className="bg-white_ p-6 rounded-2xl shadow-lg w-96 relative text-center padding">
            {/* <h3 style={{fontWeight:'700',color:'maroon'}}><u>Lakshadeepam Online Pass Availability Applications</u></h3>
            <p style={{fontSize:'15pt',fontWeight:'700',lineHeight:'20pt',color:'black',marginBottom:'25px'}}>
              Online Booking for remaining 187 Lakshadeepam passes will commence on 11.01.2026 at 11:00 AM
            </p><br /> */}

            {/* <div className="row" style={{ marginBottom: '50px' }}>
              <div className="col-md-2" style={{ backgroundImage: 'url(https://spst.in/images/pass.png)', height: '250px', backgroundSize: 'cover', backgroundPosition: 'center' }}>
              </div>
              <div className="col-md-7" style={{ background: 'orange', border: '1px solid maroon', height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '250px' }}>
                <div style={{ padding: '10px' }}>
                  <p style={{ fontSize: '20pt', lineHeight: '20pt', fontWeight: '600', color: 'maroon', lineHeight: '25pt' }}>
                    Lakshadeepam Murajapam 2025-2026 Makara Seeveli
                  </p> <br />

                  <Link to="#" target="blank" className="btn btn-primary" style={{ fontSize: '20pt', background: 'orange', color: 'maroon', border: '1px solid maroon', fontWeight: '700',background:'white' }}>Watch LIVE </Link>
                  <br />
                </div>
              </div>
              <div className="col-md-3" style={{ background: 'maroon', height: '250px' }}>
                <img src="https://spst.in/images/vilakku.png" alt="Deepam" style={{ height: '100%' }} />
              </div>
            </div> */}
            <div className="row" >
              <div className="col-md-2" style={{ backgroundImage: 'url(https://spst.in/images/pass.png)', height: '250px', backgroundSize: 'cover', backgroundPosition: 'center' }}>
              </div>
              <div className="col-md-7" style={{ background: 'maroon', border: '1px solid maroon', height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '250px' }}>
                <div style={{ padding: '10px' }}>
                  <p style={{ fontSize: '20pt', lineHeight: '20pt', fontWeight: '600', color: 'orange', lineHeight: '25pt' }}>
                    Lakshadeepam 2025-2026
                  </p> <br />
                  <a href="https://spstpassbooking.in" target="blank" className="btn btn-warning" style={{ color: 'maroon', fontSize: '15pt', fontWeight: '600' }}>Book </a>

                  <br />
                </div>
              </div>
              <div className="col-md-3" style={{ background: 'maroon', height: '250px' }}>
                <img src="https://spst.in/images/vilakku.png" alt="Deepam" style={{ height: '100%' }} />
              </div>
            </div>
            <div className="row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px', marginBottom: '20px' }}>
              <div class="col-12 col-md-6">
                <div style={{ background: 'rgba(117, 80, 0, 1)', padding: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', borderRadius: '0px 60px 0px 6  0px', border: '2px solid white', borderRadius: '25px' }}>
                  <div>
                    <img src="https://spst.in/images/pgm.png" alt="book" style={{ width: '30%' }} />
                    <p style={{ fontSize: '18pt', lineHeight: '20pt', fontWeight: '600', color: 'white' }}>
                      Murajapam Vazhipad Booking
                    </p>
                  </div>


                  <a href="https://booking.sreepadmanabhaswamytemple.org/murajapam/" className="btn btn-warning" style={{ color: 'maroon', fontSize: '15pt', padding: '20px', fontWeight: '600' }}>Book </a>

                </div>
              </div>
            </div>



            <div style={{ border: '1px solid white', background: 'white', padding: '50px' }}>
              <div>
                <h2 className="text-xl font-semibold mb-3 warning-heading">ATTENTION DONORS</h2>
              </div>
              <div className="col-md-12">
                <p className="mb-4 warning-text" >Devotees who are desirous of making donations either to Temple or for the ongoing Murajapam - Lakshadeepam 2025-26 are hereby informed, that Sree Padmanabha Swamy Temple Administration has not authorized any individual, group or organisation/association to solicit donation or collect money on the behalf of Sree Padmanabha Swamy Temple. Devotees are therefore strictly warned not to respond to any such request or call made by any such individual, or organisation in this regard. All such contribution shall be made only to the following accounts for the purpose noted against each.</p>
              </div>
              <div className="row account-details">
                <div classname="col-md-6">
                  <div style={{ padding: '15px', marginBottom: '25px' }}>
                    <p style={{ fontSize: '15pt' }}>
                      <b><u>Murajapam - Lakshadeepam Donations</u></b> <br />

                      Alc Name: Murajapam-Lakshadeepam 2025-26. <br />
                      A/C No.: <span style={{ fontWeight: '800', color: 'maroon' }}>0820101027466</span> <br />
                      IFSC Code: <span style={{ fontWeight: '800', color: 'maroon' }}>CNRB0014005</span>

                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ padding: '15px', }}>
                    <p style={{ fontSize: '15pt' }}>
                      <b><u>Other Donations</u></b> <br />

                      Alc Name: SREE PADMANABHA SWAMY TEMPLE <br />
                      A/C No.: <span style={{ fontWeight: '800', color: 'maroon' }}>40052010005831</span> <br />
                      IFSC Code: <span style={{ fontWeight: '800', color: 'maroon' }}>CNRB0014005</span>

                    </p>
                  </div>
                </div>

              </div>

            </div>






            {/* <a href="https://booking.sreepadmanabhaswamytemple.org/murajapam/" className="btn btn-primary" style={{fontSize:'18pt'}}>Click here to Book Murajapam Vazhipad</a><br /> */}



            <button
              onClick={closePopup}
              className="bg-blue-600  px-4 py-2 rounded-lg hover:bg-blue-700" style={{ background: 'white', border: '1px solid maroon', color: 'maroon', fontWeight: '700', fontSize: '15pt', marginTop: '50px' }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Popup;
